module.exports = __webpack_public_path__ + "img/vertical_4_4_8004.a04e869b.png";